import React, { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";
import AnthologyBrowser from "./browse/AnthologyBrowser";
import {
  Route,
  useLocation,
  useRouteMatch,
  useHistory,
} from "react-router-dom";
import withAuthorization from "../../auth/withAuthorization";
import { useSearch } from "../searchServices";
import { mergeDeepRight } from "ramda";
import AnthologyEdit from "./edit/AnthologyEdit";
import { creatorRoles } from "../../auth/authUtils";

const useStyles = makeStyles(theme => ({
  panel: {
    display: "flex",
    flexDirection: "column",
    height: "95%",
    padding: "0",
    border: "3px solid white",
    background: "white",
    borderRadius: "20px",
  },
}));

const initialSearchState = (initialState = {}) => {
  return mergeDeepRight(
    {
      appliedQuery: [],
      appliedFacets: [
        {
          name: "type",
          queryParam: "_type",
          terms: [
            {
              code: "ANTHOLOGY",
            },
          ],
        },
        {
          name: "status",
          queryParam: "status",
          terms: [{ code: "(-status:* AND *:*)" }, { code: "status:*" }],
        },
      ],
      orderBy: null,
      orderDirection: "asc",
      otherParams: [],
      appliedPublicationYearGroups: [],
      titleOnly: false,
      moduleOnly: false,
      page: 0,
      noFacets: true,
    },
    initialState,
  );
};

// TODO: refactor edit dialog routing
// Setting withAuthorization to false to not show unauthorized screen because
// unauthorized screen flashes when navigating to and away from edit screen for non-Admin users
const AuthorizedRoute = withAuthorization(Route, false);

const AnthologyView = () => {
  const classes = useStyles();
  const { path } = useRouteMatch();
  const location = useLocation();
  const history = useHistory();
  const initialSearch = (location.state && location.state.search) || [];

  const [searchState, setSearchState] = useState(
    initialSearchState(initialSearch),
  );

  const searchResults = useSearch(searchState);

  const handleSave = useCallback(() => {
    searchResults.refetch();
    history.goBack();
  }, [searchResults, history]);

  const handleCancel = useCallback(() => {
    history.goBack();
  }, [history]);

  return (
    <Container
      id="anthology-view"
      maxWidth={false}
      classes={{ root: classes.panel }}
    >
      <AuthorizedRoute exact path={`${path}`} roles={["ROLE_ADMIN"]}>
        <AnthologyBrowser
          searchState={searchState}
          onSearchStateChange={state => setSearchState(state)}
          searchResults={searchResults}
          onSaveSuccess={handleSave}
        />
      </AuthorizedRoute>
      <AuthorizedRoute path={`${path}/:id`} roles={creatorRoles}>
        <AnthologyEdit onCancel={handleCancel} />
      </AuthorizedRoute>
    </Container>
  );
};

export default AnthologyView;
